module.exports = __webpack_public_path__ + "13_hair_brown.62fc2f1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/13_hair_brown.png
// module id = 96Dv
// module chunks = 0